import { ListDataSource } from 'src/app/_shared/classes/list-datasource';
import { SharedFragment } from 'src/app/_shared/fragments/shared.fragment';
import {
    GedCriteresFiltrageGedModelInput, GedListeAlbumsGedModel,
    MutationGetListeAlbumsGedModelArgs, PortailAlbumDto,
} from 'src/graphql/generated-types';
import gql from 'graphql-tag';
import { map } from 'rxjs/operators';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { Observable } from 'rxjs';


export class FolderBankListDatasource extends ListDataSource<PortailAlbumDto> {

    protected numberOfElementsByPage = 50;

    constructor(private readonly graphqlService: GraphqlService) {
        super();
        this.subscriptionsList.push(this.changePage().subscribe());
    }

    reset(): void {
        super.reset();
        this.subscriptionsList.push(this.changePage().subscribe());
    }

    setFilters(filters: GedCriteresFiltrageGedModelInput = null): void {
        this.filters = filters;
    }

    getList(): Observable<any> {
        return this.getListeDocumentsGEDModel({
            ...this.filters,
            OrderByID: true,
            Skip: this.skip,
            Take: this.numberOfElementsByPage,
        }).pipe(
            map((folders: GedListeAlbumsGedModel) => {
                const list = folders?.ListeAlbums?.PortailAlbumDTO || [];
                return {list, total: folders?.NbElementTot || 0};
            }),
        );
    }

    getListeDocumentsGEDModel(criteres: GedCriteresFiltrageGedModelInput): Observable<GedListeAlbumsGedModel> {
        return this.graphqlService.mutateOne<'getListeAlbumsGEDModel', MutationGetListeAlbumsGedModelArgs>({
            mutation: gql`
            mutation getListeAlbumsGEDModel($contexte: ContextInfosInput, $criteres: GEDCriteresFiltrageGEDModelInput) {
                getListeAlbumsGEDModel(contexte: $contexte, criteres: $criteres) {
                    ... folders
                }
            }
             ${SharedFragment.folders}`,
            variables: {criteres}
        });
    }
}
